import React, { Component } from 'react';
import { Paper, Typography, TextField, Button, FormControlLabel, Checkbox, Box, Tooltip, CircularProgress } from '@material-ui/core';
import { connect } from 'react-redux';
import { instajobThemeDark } from '../shared/helpers/instajobTheme';
import { ThemeProvider } from '@material-ui/styles';
import PasswordField from '../shared/components/PasswordField';
import authService from '../api/authService';

import './LoginPage.css';
import image from '../assets/instajob-logo.png';

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            keepSession: false, 
            isLoading: false
        };

        this.changeEmail = this.changeEmail.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.changeKeepSession = this.changeKeepSession.bind(this);
        this.changeIsLoading = this.changeIsLoading.bind(this);
        this.tryLogin = this.tryLogin.bind(this);
    }

    tryLogin() {
        authService.login(this.state.email, this.state.password, this.state.keepSession)
        .finally(
            this.changeIsLoading()
        );
    }

    changeIsLoading(evt){
        this.setState({
            isLoading: !this.state.isLoading
        });
    }

    changeEmail(evt) {
        this.setState({
            email: evt.target.value
        });
    }

    changePassword(evt) {
        this.setState({
            password: evt.target.value
        });
    }

    changeKeepSession(evt) {
        this.setState({
            keepSession: evt.target.checked
        });
    }

    render() {
        const { email, password, keepSession } = this.state;
        return (
            <ThemeProvider theme={instajobThemeDark}>
                <Box className="background-login">
                    <Paper className="form-login">
                        <div style={{ width: '100%', textAlign: 'center' }}>
                            <img src={image} style={{ maxWidth: '50%', alignSelf: 'center' }} alt="InstaJob Logo" />
                        </div>
                        <section style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'center' }} variant="body1">Welcome to InstaJob BackOffice</Typography>

                            <TextField
                                autoFocus
                                variant="outlined"
                                margin="normal"
                                id="email"
                                label="Your e-mail"
                                type="email"
                                autoComplete={false}
                                onChange={this.changeEmail}
                                value={email}
                                fullWidth
                            />

                            <PasswordField
                                margin="normal"
                                id="password"
                                variant="outlined"
                                autoComplete={false}
                                label="Password"
                                onChange={this.changePassword}
                                value={password}
                                fullWidth={true} />

                            <Tooltip title="Keeping your session will prevent you to login several times.">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="primary"
                                            checked={keepSession}
                                            onChange={this.changeKeepSession}
                                            inputProps={{
                                                'aria-label': 'primary checkbox',
                                            }}
                                        />
                                    }
                                    label="Keep your session?"
                                />

                            </Tooltip>

                            <Button variant="contained" color="primary" onClick={this.tryLogin}>
                                {
                                    !this.state.isLoading ? 
                                    "Login"
                                    :
                                    <CircularProgress size={24} style={{ color: 'white' }} />
                                }
                            </Button>
                        </section>
                    </Paper>
                </Box>

            </ThemeProvider>
        )
    }
}

export default connect()(LoginPage);